module.exports = __webpack_public_path__ + "static/img/logos.7a0d6e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos.png
// module id = rcg2
// module chunks = 0